import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommentDatePipe } from './pipe/comment-date.pipe';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [CommentDatePipe],
  exports: [CommentDatePipe]
})
export class CommentsDataModule {}
